import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import Search from '@material-ui/icons/Search'
import { withStyles } from '@material-ui/core/styles'

import { COLORS } from 'Constants/Theme'

const styles = {
  container: {
    marginLeft: 20,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  icon: {
    fontSize: 18,
    paddingTop: 2,
    paddingLeft: 6,
    fontWeight: 800,
    color: COLORS.PRIMARY,
  },
}

const SearchIcon = ({ classes, customClasses }) => (
  <div className={classnames(classes.container, customClasses.container)}>
    <Search className={classnames(classes.icon, customClasses.icon)} />
  </div>
)

SearchIcon.defaultProps = {
  customClasses: {},
}

SearchIcon.propTypes = {
  customClasses: PropTypes.object,
  classes: PropTypes.object.isRequired,
}

export default withStyles(styles)(SearchIcon)
